import { ca } from '@cian/analytics';

import { EMortgageOffersTabs } from '../../enums/EMortgageOffersTabs';

import { IPromoIdExtraObject, getProductsData } from '../../utils/getProductsData';
import { IPromo } from '../../types/promos';

const ANALYTICS_TABS_MAP: Record<EMortgageOffersTabs | 'seoUrl', string> = {
  [EMortgageOffersTabs.Banks]: 'accredited_banks',
  [EMortgageOffersTabs.Mortgage]: 'mortgage_offers',
  seoUrl: 'seo_url',
};

export function trackMortgageOffersTabClick(tab: EMortgageOffersTabs | 'seoUrl'): void {
  ca('eventSite', {
    action: 'click',
    category: 'Promo',
    label: ANALYTICS_TABS_MAP[tab],
    name: 'oldevent',
    useLastProducts: true,
  });
}

export function trackPromoOffersShow(promos: IPromo[]) {
  const promoId = promos.map<IPromoIdExtraObject>((promo, index) => ({
    position: index + 1,
    promo_id: parseInt(promo.uniquePromoId, 10),
    promo_type: promo.promoType,
  }));

  ca('eventSite', {
    action: 'show_sopr',
    category: 'Promo',
    label: 'mortgage_offers',
    name: 'oldevent',
    products: [getProductsData({ promoId })],
  });
}
